const massimo = () => {

  // Mega Menu
  document.addEventListener('DOMContentLoaded', () => {
    

    const isDesktop = window.innerWidth >= 992;
  const isMobile  = window.innerWidth < 992;

  /////////////////////////////////////////////////////////
  // DESKTOP – MEGA MENU HOVER
  /////////////////////////////////////////////////////////
  if (isDesktop) {

    const items = document.querySelectorAll('.menu-lv1.has-mega');

    items.forEach(item => {
      const mega = item.querySelector('.mega-menu');
      if (!mega) return;

      let overTrigger = false;
      let overMega = false;

      const updateState = () => {
        if (overTrigger || overMega) {
          item.classList.add('is-open');
        } else {
          item.classList.remove('is-open');
        }
      };

      // TRIGGER
      item.addEventListener('mouseenter', () => {
        overTrigger = true;
        updateState();
      });

      item.addEventListener('mouseleave', () => {
        overTrigger = false;
        updateState();
      });

      // MEGA MENU
      mega.addEventListener('mouseenter', () => {
        overMega = true;
        updateState();
      });

      mega.addEventListener('mouseleave', () => {
        overMega = false;
        updateState();
      });
    });
  }

  /////////////////////////////////////////////////////////
  // MOBILE – OVERLAY + DRILLDOWN
  /////////////////////////////////////////////////////////
  if (isMobile) {
const backBtn = document.querySelector('.mobile-back');
  const parents = document.querySelectorAll('.menu-item-has-children');

  parents.forEach(item => {

    const link = item.querySelector('a');

    link.addEventListener('click', function(e) {
      e.preventDefault();
      item.classList.add('drill-open');
      

      if (backBtn) backBtn.classList.add('active');
    });

  });

  if (backBtn) {
    backBtn.addEventListener('click', () => {

      const openItem = document.querySelector('.menu-lv1.drill-open');
      if (openItem) {
        openItem.classList.remove('drill-open');
      }

      backBtn.classList.remove('active');
    });
  }
  }

  






    const params = new URLSearchParams(window.location.search);
    const targetId = params.get("open");

    console.log('ci siamo siamo');
    if (!targetId) return;

    const targetCollapse = document.getElementById(targetId);

    if (!targetCollapse) return;

    const collapse = new bootstrap.Collapse(targetCollapse, {
        toggle: true
    });

    targetCollapse.addEventListener('shown.bs.collapse', function () {

        const offset = 210; // se hai header fisso
        const elementPosition = targetCollapse.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });

    }, { once: true });




  });


  document.addEventListener('DOMContentLoaded', () => {

  if (window.innerWidth >= 992) return;

  const collapse = document.querySelector('.navbar-collapse');
  const parents  = document.querySelectorAll('.menu-item-has-children');
  const mobilePanel = document.querySelector('.megamenumobile');
  const backBtn  = document.querySelector('.mobile-back');

  let originalColumns = [];

  parents.forEach(item => {

    const trigger = item.querySelector('.menu-lv1-link');
    const columns = item.querySelectorAll('.mega-col');

    if (!columns.length) return;

    trigger.addEventListener('click', function(e) {
      e.preventDefault();

      originalColumns = [];

      columns.forEach(col => {

        const title = col.querySelector('.mega-title');
        if (!title) return;

        originalColumns.push({
          parent: col,
          element: title
        });

        mobilePanel.appendChild(title);
      });

      mobilePanel.classList.add('active');
      backBtn.classList.add('active');
      collapse.classList.add('panel-mode');
    });

  });

  backBtn.addEventListener('click', () => {

    originalColumns.forEach(obj => {
      obj.parent.prepend(obj.element);
    });

    mobilePanel.innerHTML = '';
    mobilePanel.classList.remove('active');
    backBtn.classList.remove('active');
    collapse.classList.remove('panel-mode');
  });

});


};

export default massimo;
